module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BAllBlog"
  }, [_c('div', {
    staticClass: "allBlogContent"
  }, [_c('v-article', {
    attrs: {
      "articleList": _vm.articleList,
      "articleCount": _vm.articleCount,
      "currentPage": _vm.currentPageCopy,
      "pageNum": _vm.pageNum,
      "isLoading": _vm.isLoading,
      "toEdit": true,
      "isArticle": true
    },
    on: {
      "getCategories": _vm.getCategories,
      "showMessage": _vm.showMessage
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ba776ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/BAM/view/allBlog.vue
// module id = 261
// module chunks = 1